import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NextArrow, PrevArrow } from '../Shared';
import Slider from "react-slick";
import { API, Helpers, Router } from '../Helpers';

export default class PostsCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.generateProductUrl = this.generateProductUrl.bind(this);
        
    }

    generateProductUrl(post)
    {
        const router = Router([{name: "customer.posts.show", url: "{domain}/inspiration/{post}"}]);

        let params = {
            domain: this.props.data.active_site.domain, 
            post: post.slug
        };
        
        return router.url('customer.posts.show', params);
    }

    render() {
        
        const { posts } = this.props.data;
        
        return (
            <div className="container">
            {
                !_.isEmpty(posts.data) &&
                <div className="row">
                    <div className="col-12">
                            <Slider {...{
                                className: "slick-carousel h-100",
                                infinite: true,
                                initialSlide: 0,
                                slidesToShow: posts.data.length >= 4 ? 4 : 3,
                                slidesToScroll: 1,
                                prevArrow: <PrevArrow />,
                                nextArrow: <NextArrow />,
                                responsive: [
                                    {
                                        breakpoint: 1200,
                                        settings: {
                                            slidesToShow: posts.data.length >= 4 ? 4 : 3,
                                            slidesToScroll: 1
                                        }
                                    },
                                    {
                                        breakpoint: 1024,
                                        settings: {
                                            arrows: false,
                                            centerMode: true,
                                            centerPadding: '20px',
                                            slidesToShow: 2,
                                            slidesToScroll: 1
                                        }
                                    },
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            arrows: false,
                                            centerMode: true,
                                            centerPadding: '20px',
                                            slidesToShow: 1,
                                            slidesToScroll: 1
                                        }
                                    }
                                ]
                            }}>

                            {
                                posts.data.map((post, key) => {
                                    const created_at = Helpers.toFormattedDateString(post.created_at);
                                    const product_url = this.generateProductUrl(post);
                                    
                                    return (
                                        <div key={key} className="position-relative h-100">
                                            <a href={product_url} className="">
                                                <div className="card rounded-0 border">
                                                    <div className="card-image overflow-hidden position-relative">
                                                        <img className="img-fluid" src={post.featured_image} />
                                                    </div>

                                                    <div className="card-body border-top-0 position-relative">
                                                        <ul className="list-inline text-muted font-small mb-3">
                                                            <li className="list-inline-item">{created_at}</li>
                                                            <li className="list-inline-item">|</li>
                                                            <li className="list-inline-item">{post.post_category.name || ''}</li>
                                                        </ul>

                                                        <h4 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-none d-lg-webkit-box">
                                                            {post.title}
                                                        </h4>

                                                        <h5 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-lg-none">
                                                            {post.title}
                                                        </h5>

                                                        <div className="three-b-text">{post.excerpt || ''}</div>
                                                    </div>
                                                    
                                                </div>
                                            </a>
                                        </div>
                                    )
                                })
                            }
                            </Slider>
                    </div>
                </div>
                
            }
        </div>
        );
    }
}

if (document.getElementById('postsCarousel')) {
    
    const element = document.getElementById('postsCarousel');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<PostsCarousel data={JSON.parse(data.data)} />, document.getElementById('postsCarousel'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/PostsCarousel.js